var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticClass:"w100",attrs:{"data":_vm.directories,"stripe":"","row-class-name":"pointer"},on:{"row-click":_vm.click}},[_c('el-table-column',{attrs:{"label":"Directory"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"capitalize"},[_vm._v(_vm._s(props.row))])]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }